var map = {
	"./logo-aachen.png": 9339,
	"./logo-brown.png": 6885,
	"./logo-caltech.png": 9617,
	"./logo-cambridge.png": 8771,
	"./logo-cmu.png": 6168,
	"./logo-columbia.png": 9113,
	"./logo-cornell.png": 2646,
	"./logo-delft.png": 8052,
	"./logo-dtu.png": 320,
	"./logo-edinburgh.png": 3461,
	"./logo-epfl.png": 5120,
	"./logo-essec.png": 3446,
	"./logo-eth.png": 3356,
	"./logo-fudan.png": 5781,
	"./logo-hanyang.png": 7999,
	"./logo-harvard.png": 9469,
	"./logo-hec.png": 1069,
	"./logo-heidelberg.png": 5982,
	"./logo-helsinki.png": 1766,
	"./logo-ic.png": 6013,
	"./logo-iit.png": 3715,
	"./logo-johnshopkins.png": 1191,
	"./logo-kaust.png": 5613,
	"./logo-kul.png": 3753,
	"./logo-lse.png": 3105,
	"./logo-lum.png": 2911,
	"./logo-lunds.png": 5819,
	"./logo-mcgill.png": 8017,
	"./logo-mcmaster.png": 599,
	"./logo-melbourne.png": 1580,
	"./logo-michigan.png": 2571,
	"./logo-mit.png": 5143,
	"./logo-nju.png": 6584,
	"./logo-ntu.png": 8050,
	"./logo-nus.png": 2959,
	"./logo-nyu.png": 7901,
	"./logo-oslo.png": 9448,
	"./logo-oxford.png": 9059,
	"./logo-peking.png": 9777,
	"./logo-penn.png": 5788,
	"./logo-princeton.png": 27,
	"./logo-seoul.png": 181,
	"./logo-sfu.png": 6437,
	"./logo-stanford.png": 7230,
	"./logo-stockholms.png": 2378,
	"./logo-sydney.png": 9321,
	"./logo-taiwan.png": 4061,
	"./logo-tam.png": 3915,
	"./logo-tokyo.png": 2231,
	"./logo-toronto.png": 1698,
	"./logo-tsinghua.png": 4960,
	"./logo-tue.png": 7807,
	"./logo-tum.png": 4007,
	"./logo-ubc.png": 9641,
	"./logo-ucberkeley.png": 7958,
	"./logo-ucl.png": 8977,
	"./logo-ucm.png": 6264,
	"./logo-uhongkong.png": 6877,
	"./logo-uiuc.png": 799,
	"./logo-unsw.png": 2022,
	"./logo-vienna.png": 7276,
	"./logo-waterloo.png": 8108,
	"./logo-yale.png": 3686,
	"./logo-zju.png": 7892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7162;